module.exports = __webpack_public_path__ + "static/img/long-activity-banner.3a5d8ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/long-activity-banner.png
// module id = 2ARr
// module chunks = 215